import React from 'react'

import styles from './index.module.css'

// https://codepen.io/MHWK/pen/WEXdGB
const LoadingSpinner = ({ strokeColor = 'hsl(86, 47%, 48%)', ...props }) => (
  <svg
    className={styles.spinner}
    width="65px"
    height="65px"
    viewBox="0 0 66 66"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      className={styles.path}
      fill="none"
      strokeWidth="6"
      strokeLinecap="round"
      stroke={strokeColor}
      cx="33"
      cy="33"
      r="30"
    />
  </svg>
)

export default LoadingSpinner



// WEBPACK FOOTER //
// ./client/components/icons/loadingSpinner/index.js